(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-bb-announce]').forEach(function (root) {
      var track = root.querySelector('[data-bb-track]');
      if (!track) return;

      // Pause when tab is hidden to save battery on mobile
      document.addEventListener('visibilitychange', function () {
        track.style.animationPlayState = document.hidden ? 'paused' : 'running';
      });

      // Theme-editor: pause animation on the block being edited so merchant can read it
      document.addEventListener('shopify:block:select', function (e) {
        if (root.contains(e.target)) track.style.animationPlayState = 'paused';
      });
      document.addEventListener('shopify:block:deselect', function (e) {
        if (root.contains(e.target)) track.style.animationPlayState = 'running';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-category-row"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('[data-bb-catrow]').forEach(function(root){
      if(root.dataset.autoscroll !== 'true') return;
      var sc = root.querySelector('[data-bb-cat-scroller]');
      if(!sc) return;
      var timer, dir = 1;
      function isGrid(){ return getComputedStyle(sc).display === 'grid'; }
      function tick(){
        if(isGrid() || sc.matches(':hover')) return;
        if(sc.scrollLeft + sc.clientWidth >= sc.scrollWidth - 2) dir = -1;
        else if(sc.scrollLeft <= 0) dir = 1;
        sc.scrollBy({ left: dir * 1, behavior: 'auto' });
      }
      function start(){ stop(); timer = setInterval(tick, 24); }
      function stop(){ if(timer) clearInterval(timer); }
      ['touchstart','mouseenter'].forEach(function(ev){ sc.addEventListener(ev, stop); });
      ['touchend','mouseleave'].forEach(function(ev){ sc.addEventListener(ev, start); });
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-faq"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('[data-bb-faq]').forEach(function(root){
      if(root.dataset.single !== 'true') return;
      var items = root.querySelectorAll('.bb-faq__item');
      items.forEach(function(item){
        item.querySelector('.bb-faq__q').addEventListener('click', function(){
          if(!item.open){ items.forEach(function(o){ if(o!==item) o.open=false; }); }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var WKEY = 'bb_wishlist';
    function read(){ try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch(e){ return []; } }
    function write(a){ localStorage.setItem(WKEY, JSON.stringify(a)); sync(); }

    function lock(on){ document.body.classList.toggle('bb-noscroll', on); }
    function openEl(el){ el.hidden=false; requestAnimationFrame(function(){ el.classList.add('is-open'); }); lock(true); }
    function closeEl(el){ el.classList.remove('is-open'); lock(false); setTimeout(function(){ el.hidden=true; }, 280); }

    // Mobile menu
    var mob = document.querySelector('[data-bb-mobnav]');
    document.querySelectorAll('[data-bb-menu-open]').forEach(function(b){ b.addEventListener('click', function(){ openEl(mob); }); });
    document.querySelectorAll('[data-bb-menu-close]').forEach(function(b){ b.addEventListener('click', function(){ closeEl(mob); }); });

    // Wishlist drawer
    var wish = document.querySelector('[data-bb-wish]');
    var body = wish ? wish.querySelector('[data-bb-wish-body]') : null;
    var empty = wish ? wish.querySelector('[data-bb-wish-empty]') : null;
    document.querySelectorAll('[data-bb-wish-open]').forEach(function(b){ b.addEventListener('click', function(){ render(); openEl(wish); }); });
    document.querySelectorAll('[data-bb-wish-close]').forEach(function(b){ b.addEventListener('click', function(){ closeEl(wish); }); });

    function money(v){ return '₹' + Number(v).toLocaleString('en-IN'); }

    function render(){
      if(!body) return;
      var items = read();
      body.innerHTML = '';
      if(items.length === 0){ empty.hidden = false; body.hidden = true; return; }
      empty.hidden = true; body.hidden = false;
      items.forEach(function(it){
        var row = document.createElement('div');
        row.className = 'bb-wish__row';
        row.innerHTML =
          '<img class="bb-wish__thumb" src="'+(it.image||'')+'" alt="" loading="lazy">'+
          '<div class="bb-wish__info">'+
            '<a class="bb-wish__name" href="'+(it.url||'#')+'">'+(it.title||'Product')+'</a>'+
            '<span class="bb-wish__price">'+money(it.price)+'</span>'+
            '<div class="bb-wish__rowactions">'+
              '<button class="bb-wish__atc" data-id="'+it.id+'" data-variant="'+(it.variant||it.id)+'">Add to Cart</button>'+
              '<button class="bb-wish__remove" data-remove="'+it.id+'" aria-label="Remove">'+
                '<svg viewBox="0 0 24 24" fill="none"><path d="M5 7h14M9 7V5h6v2m-8 0 1 12h8l1-12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'+
              '</button>'+
            '</div>'+
          '</div>';
        body.appendChild(row);
      });
      body.querySelectorAll('[data-remove]').forEach(function(b){
        b.addEventListener('click', function(){ write(read().filter(function(x){ return String(x.id) !== b.dataset.remove; })); render(); });
      });
      body.querySelectorAll('[data-variant]').forEach(function(b){
        b.addEventListener('click', function(){
          fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ id: b.dataset.variant, quantity: 1 }) })
            .then(function(r){ return r.json(); })
            .then(function(){ b.textContent = 'Added ✓'; bumpCart(); setTimeout(function(){ b.textContent='Add to Cart'; }, 1400); })
            .catch(function(){ b.textContent='Try again'; });
        });
      });
    }

    function sync(){
      var n = read().length;
      document.querySelectorAll('[data-bb-wish-count]').forEach(function(el){ el.textContent = n; el.hidden = n === 0; });
      document.querySelectorAll('[data-bb-wish-headcount]').forEach(function(el){ el.textContent = n ? '('+n+')' : ''; });
    }
    function bumpCart(){
      fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
        document.querySelectorAll('[data-bb-cart-count]').forEach(function(el){ el.textContent = c.item_count; el.hidden = c.item_count === 0; });
      }).catch(function(){});
    }

    document.addEventListener('keydown', function(e){ if(e.key === 'Escape'){ if(wish&&wish.classList.contains('is-open'))closeEl(wish); if(mob&&mob.classList.contains('is-open'))closeEl(mob); } });
    window.addEventListener('storage', function(e){ if(e.key === WKEY){ sync(); render(); } });

    sync();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-hero-banner"] && !Shopify.designMode) return;
  try {
    
  (function(){
    // Re-trigger entrance when merchant selects the section in theme editor
    document.addEventListener('shopify:section:select', function(e){
      var hero = e.target.querySelector('[data-bb-hero]') || (e.target.matches('[data-bb-hero]') ? e.target : null);
      if(!hero) return;
      hero.querySelectorAll('.bb-anim').forEach(function(el){
        el.style.animation='none'; void el.offsetWidth; el.style.animation='';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-carousel"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var WKEY='bb_wishlist';
    function read(){try{return JSON.parse(localStorage.getItem(WKEY))||[];}catch(e){return[];}}
    function write(a){localStorage.setItem(WKEY,JSON.stringify(a));window.dispatchEvent(new Event('bb:wishchange'));}

    document.querySelectorAll('[data-bb-carousel]').forEach(function(root){
      var track=root.querySelector('[data-bb-track]');
      var prev=root.querySelector('[data-bb-prev]');
      var next=root.querySelector('[data-bb-next]');
      function step(){var c=track.querySelector('.bb-card');return c?c.offsetWidth+12:220;}
      function update(){if(!prev||!next)return;prev.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;}
      if(prev)prev.addEventListener('click',function(){track.scrollBy({left:-step()*2,behavior:'smooth'});});
      if(next)next.addEventListener('click',function(){track.scrollBy({left:step()*2,behavior:'smooth'});});
      track.addEventListener('scroll',update);window.addEventListener('resize',update);update();

      // ATC
      root.querySelectorAll('[data-bb-atc]').forEach(function(btn){
        if(btn.disabled)return;
        btn.addEventListener('click',function(){
          var id=btn.getAttribute('data-variant');if(!id)return;
          var txt=btn.textContent;
          fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:1})})
            .then(function(r){return r.json();}).then(function(){btn.textContent='Added ✓';document.dispatchEvent(new CustomEvent('bb:cartupdate'));
              return fetch('/cart.js');}).then(function(r){return r.json();}).then(function(c){
                document.querySelectorAll('[data-bb-cart-count]').forEach(function(el){el.textContent=c.item_count;el.hidden=false;});
                setTimeout(function(){btn.textContent=txt;},1400);
              }).catch(function(){btn.textContent='Try again';setTimeout(function(){btn.textContent=txt;},1400);});
        });
      });

      // Wishlist heart
      function refreshHearts(){var ids=read().map(function(x){return String(x.id);});root.querySelectorAll('[data-bb-wish-add]').forEach(function(b){b.classList.toggle('is-active',ids.indexOf(b.dataset.id)>-1);});}
      root.querySelectorAll('[data-bb-wish-add]').forEach(function(btn){
        btn.addEventListener('click',function(e){
          e.preventDefault();
          var list=read();var id=btn.dataset.id;var i=list.findIndex(function(x){return String(x.id)===id;});
          if(i>-1){list.splice(i,1);}else{list.push({id:id,variant:btn.dataset.variant,title:btn.dataset.title,price:parseFloat(btn.dataset.price),image:btn.dataset.image,url:btn.dataset.url});}
          write(list);refreshHearts();
        });
      });
      window.addEventListener('bb:wishchange',refreshHearts);window.addEventListener('storage',refreshHearts);refreshHearts();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-main"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var WKEY='bb_wishlist';
    function readW(){try{return JSON.parse(localStorage.getItem(WKEY))||[];}catch(e){return[];}}
    function writeW(a){localStorage.setItem(WKEY,JSON.stringify(a));window.dispatchEvent(new Event('bb:wishchange'));}

    document.querySelectorAll('[data-bb-pdp]').forEach(function(root){
      var variants=[];
      try{ variants = JSON.parse(root.querySelector('[data-bb-variants]').textContent); }catch(e){}
      var sel = root.querySelector('[data-bb-variant-select]');

      // Gallery thumbs
      var stage = root.querySelector('[data-bb-stage]');
      root.querySelectorAll('[data-bb-thumbs] .bb-pdp__thumb').forEach(function(t){
        t.addEventListener('click', function(){
          var i = +t.dataset.index;
          var slide = stage.querySelector('.bb-pdp__slide[data-index="'+i+'"]');
          if(slide) stage.scrollTo({ left: slide.offsetLeft, behavior:'smooth' });
          root.querySelectorAll('[data-bb-thumbs] .bb-pdp__thumb').forEach(function(x){x.classList.remove('is-active');});
          t.classList.add('is-active');
        });
      });
      if(stage){ stage.addEventListener('scroll', function(){
        var i = Math.round(stage.scrollLeft / stage.clientWidth);
        root.querySelectorAll('[data-bb-thumbs] .bb-pdp__thumb').forEach(function(x){ x.classList.toggle('is-active', +x.dataset.index===i); });
      }); }

      // Variant option selection
      function currentOptions(){
        var opts=[];
        root.querySelectorAll('[data-bb-opt-input]:checked').forEach(function(inp){ opts[+inp.dataset.optionIndex]=inp.value; });
        return opts;
      }
      function findVariant(opts){
        return variants.find(function(v){ return (v.options||[]).every(function(o,i){ return o===opts[i]; }); });
      }
      function money(c){ return '₹'+(c/100).toLocaleString('en-IN'); }
      function updateVariant(){
        var opts=currentOptions();
        var v=findVariant(opts);
        if(!v) return;
        if(sel) sel.value=v.id;
        var priceEl=root.querySelector('[data-bb-price]'); if(priceEl) priceEl.textContent=money(v.price);
        var mrpEl=root.querySelector('[data-bb-mrp]'); var discEl=root.querySelector('[data-bb-disc]');
        if(v.compare_at_price && v.compare_at_price>v.price){
          if(mrpEl) mrpEl.textContent=money(v.compare_at_price);
          if(discEl) discEl.textContent=Math.round((v.compare_at_price-v.price)/v.compare_at_price*100)+'% OFF';
        } else { if(mrpEl) mrpEl.style.display='none'; if(discEl) discEl.style.display='none'; }
        var skuEl=root.querySelector('[data-bb-sku]'); if(skuEl && v.sku) skuEl.textContent=v.sku;
        var availEl=root.querySelector('[data-bb-avail]');
        if(availEl){ availEl.textContent=v.available?'In Stock':'Out of Stock'; availEl.className=v.available?'is-in':'is-out'; }
        var atc=root.querySelector('[data-bb-atc]'); var buy=root.querySelector('[data-bb-buynow]'); var atcText=root.querySelector('[data-bb-atc-text]');
        if(atc){ atc.disabled=!v.available; } if(buy){ buy.disabled=!v.available; } if(atcText){ atcText.textContent=v.available?'Add to Cart':'Sold Out'; }
        // ship bar uses new price
        var ship=root.querySelector('[data-bb-ship]'); if(ship){ ship.dataset.price=v.price; updateShip(); }
      }
      root.querySelectorAll('[data-bb-opt-input]').forEach(function(inp){
        inp.addEventListener('change', function(){
          var idx=+inp.dataset.optionIndex;
          root.querySelectorAll('[data-bb-opt-input][data-option-index="'+idx+'"]').forEach(function(x){ x.closest('.bb-pdp__swatch').classList.toggle('is-selected', x.checked); });
          var lbl=root.querySelector('[data-bb-opt-selected="'+idx+'"]'); if(lbl) lbl.textContent=inp.value;
          updateVariant();
        });
      });

      // Quantity
      var qty=root.querySelector('[data-bb-qty]');
      root.querySelector('[data-bb-qty-dec]') && root.querySelector('[data-bb-qty-dec]').addEventListener('click', function(){ qty.value=Math.max(1,(+qty.value||1)-1); });
      root.querySelector('[data-bb-qty-inc]') && root.querySelector('[data-bb-qty-inc]').addEventListener('click', function(){ qty.value=(+qty.value||1)+1; });

      // Free shipping bar
      function updateShip(){
        var ship=root.querySelector('[data-bb-ship]'); if(!ship) return;
        var th=+ship.dataset.threshold; var price=(+ship.dataset.price)*(+ (qty?qty.value:1));
        var fill=ship.querySelector('[data-bb-ship-fill]'); var msg=ship.querySelector('[data-bb-ship-msg]');
        var pct=Math.min(100, price/th*100);
        if(fill) fill.style.width=pct+'%';
        if(msg){ if(price>=th){ msg.innerHTML='🎉 You\'ve unlocked <strong>FREE shipping!</strong>'; } else { msg.innerHTML='Add <strong>'+money(th-price)+'</strong> more for FREE shipping'; } }
      }
      if(qty) qty.addEventListener('input', updateShip);
      updateShip();

      // ATC via fetch (keep on page)
      var form=root.querySelector('[data-bb-form]');
      var atcBtn=root.querySelector('[data-bb-atc]');
      if(atcBtn && form){
        atcBtn.addEventListener('click', function(e){
          e.preventDefault();
          if(atcBtn.disabled) return;
          var txt=root.querySelector('[data-bb-atc-text]'); var prev=txt?txt.textContent:'';
          fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:sel.value,quantity:+qty.value||1})})
            .then(function(r){return r.json();}).then(function(){ if(txt)txt.textContent='Added ✓';
              return fetch('/cart.js');}).then(function(r){return r.json();}).then(function(c){
                document.querySelectorAll('[data-bb-cart-count]').forEach(function(el){el.textContent=c.item_count;el.hidden=false;});
                setTimeout(function(){ if(txt)txt.textContent=prev; },1400);
              }).catch(function(){ if(txt)txt.textContent='Try again'; setTimeout(function(){ if(txt)txt.textContent=prev; },1400); });
        });
      }

      // Wishlist
      function refreshHeart(){ var ids=readW().map(function(x){return String(x.id);}); var btn=root.querySelector('[data-bb-wish-add]'); if(btn) btn.classList.toggle('is-active', ids.indexOf(btn.dataset.id)>-1); }
      var wbtn=root.querySelector('[data-bb-wish-add]');
      if(wbtn){ wbtn.addEventListener('click', function(){
        var list=readW(); var id=wbtn.dataset.id; var i=list.findIndex(function(x){return String(x.id)===id;});
        if(i>-1){ list.splice(i,1);} else { list.push({id:id,variant:sel?sel.value:wbtn.dataset.variant,title:wbtn.dataset.title,price:parseFloat(wbtn.dataset.price),image:wbtn.dataset.image,url:wbtn.dataset.url}); }
        writeW(list); refreshHeart();
      }); }
      window.addEventListener('bb:wishchange', refreshHeart); window.addEventListener('storage', refreshHeart); refreshHeart();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
